export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "Matagumpay na naidagdag ang label sa iyong Trading Account.",
        ok: "OK",
        add_account_label: "Magdagdag ng Account Label",
        trading_account: "Trading Account",
        select_trading_id: "Piliin ang Trading ID",
        label: "Label",
        alpha_numeric_characters : "Magtalaga ng label sa iyong account: (Letra at numero na hanggang 15 na mga karakter)",
        apply: "Gamitin",
        cancel: "Kanselahin",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "Natanggap namin ang iyong kahilingang baguhin ang leverage ng iyong trading ID",
        from :"mula sa",
        to :"patungo sa",
        confirm_mail_id:"Upang kumpirmahin, mangyaring i-click ang link ng kumpirmasyon na ipainadala sa iyong inirehistrong e-mail ID.",
        leverage_successfully_change:"Matagumpay na naiproseso ang kahilingang baguhin ang leverage",
        change_account_leverage:"Baguhin ang Account ng Leverage",
        select_trading_account :"Piliin ang Trading Account",
        existing_leverage :"Kasalukuyang Leverage",
        new_leverage :"Bagong Leverage",
        select_new_leverage :"Pumili ng bagong Leverage",
        change_leverage:"Baguhin ang Leverage",
        account_leverage_reduced :"Kung nabawasan ang account ng leverage mula sa kasalukuyang leverage, madadagdagan nito ang ginamit na margin sa iyong bukas na mga kalakalan (kung mayroon man).",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"Kinakailangang kumpletuhin muna ang KYC upang makalikha ng mahigit sa isang account na Live.",
        submit_proof_address:"Mangyaring magsumite ng patunay ng tirahan gamit ang isang support ticket",
        click_here:"I-click dito",
        email_to: "o mag-email sa",
        contactus_aaafx_com :"makipag-ugnayan sa amin{'@'}aaafx.com",
        following_address_Proofs: "Tinatanggap ang mga sumusunod na Patunay ng Tirahan:",
        utility_bill: "Bill ng Utility",
        bank_statement: "Statement ng Bangko",
        government_issued:"Inisyu ng Pamahalaan na Dokumento sa Tax",
        note:"Nota",
        proof_of_address:"Ang patunay ng tirahan ay kinakailangang hindi lalagpas sa 4 na buwan mula nang ito ay makuha.",
        account :"Account",
        select_platform:"Piliin ang Plataporma",
        select_account_type:"Piliin ang Uri ng Account",
        connect_your_account:"Nais mo bang iugnay ang iyong account sa Zulu Trade?",
        select_leverage:"Piliin ang Leverage",
        select_account_base_currency:"Piliin ang Baseng Pananalapi ng Account",
        select_currency:"Piliin ang Pananalapi",
        Password:"Password",
        minimum_password_length5:"Ang minimum na haba ng password ay 5 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        minimum_password_length8:"Ang minimum na haba ng password ay 8 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        spcl_characters:"# ng mga karakter",
        lowercase_letter:"Maliit na letra",
        capital_letter:"Malaking letra",
        number: "Numero",
        special_character:"Espesyal na karakter",
        confirm_password :"Kumpirmahin ang Password",
        trade_With_virtual_funds:"Makipagkalakalan Gamit ang Virtual na Pondo",
        test_strategies:"Libreng mga Pagsubok na Estratehiya",
        risk_free_trading:"Walang Panganib na Pakikipagkalakalan",
        live_market_feed: "Live na Feed ng Merkado",
        liquidity_from_top :"Liquidity Mula sa Nangungunang mga LP",
        effective_trading:"Mabisang mga Tool sa Pakikipagkalakalan",
        instant_execution:"Agarang Pagpapatupad",
        low_commissions:"Mababang Komisyon at mga Spread",
        create_new:"Lumikha ng Panibago",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Paganahin ang 2 Factor Authentication",
        click_to_enable: "I-click upang Paganahin",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"Natanggap namin ang iyong kahilingang ilipat",
        from_trading_account:"mula sa trading account",
        to_confirm:"Upang kumpirmahin, mangyaring i-click abg link ng kumpirmasyon na ipinadala sa iyong inirehistrong e-mail ID.",
        internal_transfer_request:"Ang iyong kahilingan sa panloob na paglipat mula sa account",
        for_amount:"para sa halaga",
        to_account:"patungo sa account",
        was_succesfull :"ay matagumpay na may halagang",
        internal_transfer: "Panloob na Paglilipat",
        transfer_From: "Ilipat mula sa",
        transfer_to:"Ilipat patungo sa",
        balance: "Balanse",
        enter_amount: "Ipasok ang Halaga",
        USE_MAX:"GAMITIN ANG PINAKAMATAAS",
        proceed:"Magpatuloy",
        Internal_Transfer_ZIP:"Ang Panloob na Paglipat ay hindi magagamit para sa ZTP account.",
        In_case_of_internal_transfer:"Tandaan: Sa kaso ng panaloob na paglipat sa pagitan ng mga acoount na may magkaibang base ng pananalapi, ang halagang nailipat ay magiging ayon sa laganap na mga presyo sa merkado.",
         
        /*=== manage-account.vue ====*/
        attention :"Pansinin- Ikaw ay malapit na sa kahilingang burahin ang Trading ID",
        note_after_requesting:"Paalala:- Matapos humiling, ang iyong account ay mabubura mula sa mga talaan at hindi mo na maaaring ibalik ito.",
        after_clicking:"Matapos i-click ang confirm button, makakatanggap ka ng link ng kumpirmasyon sa iyong nairehistrong email ID upang burahin ang iyong trading account",
        currency: "Pera",
        Account_Type: "Uri ng Account",
        Account_Label: "Label ng Account",
        Bonus: "Bonus",
        Leverage: "Leverage",
        Equity: "Equity",
        Create_Demo_Account: "Lumikha ng Demo Account",
        Create_Live_Account :"Lumikha ng Live Account",
        internal_transfer_CAP:"PANLOOB NA PAGLIPAT",
        web_trading:"PAKIKIPAGKALAKALAN SA WEB",
        add_account_label_CAP:"MAGDAGDAG NG ACCOUNT LABEL",
        change_laverage:"BAGUHIN ANG LEVERAGE",
        delete_account:"Burahin ang Account",
        reset_trading_password:"I-RESET ANG TRADING PASSWORD",
        
        verifying_your_request: "Tinitiyak ang iyong kahilingan...",
        success: "TAGUMPAY",
        error: "MALI",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"Natanggap namin ang iyong hiling na i-reset ang Investor password. Upang kumpirmahin, mangyaring i-click ang link ng kumpirmasyon na ipinadala sa iyong nairehistrong email ID.",
        change_investor_password:"Matagumpay na Baguhin ang Investor Password",
        reset_investor_password:"I-reset ang Investor Password",
        investor_password:"Investor Password",
        master_password:"Master Password",
        trading_iD: "Trading ID",
        enter_new_password:"Ipasok ang Bagong Password",
        confirm_new_password :"Kumpirmahin ang Bagong Password",
        password_must_contain:"Ang iyong password ay kinakailanang maglaman ng di bababa sa 6 karakter at di hihigit sa 10 karakter, hindi bababa sa 1 numero, 1 malaking letra na karakter at 1 espesyal na karakter (!@$%*)",
        change_Password:"Palitan ang Password",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"I-reset ang Master Password",
        click_reset:"I-click dito para mag-reset",
        password_caption:"Ang Investor Password ay Mababasa Lamang na password, na hindi pinapayagang mangalakal ang tagagamit. Kung ikaw ay nag- log in gamit ang Master Password, makakakuha ka ng ganap na access at karapatan sa pangangalakal sa account.",},
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Corporate",
        account_type: "Uri ng Account",
        select_account_type: "Piliin ang Uri ng Account",
        individual: "Indibidwal",
        name_of_company: "Pangalan ng kompanya",
        country_of_company: "Bansa ng kompanya",
        select_company_country: "Piliin ang bansa ng kompanya",
        registration: "Pagpaparehistro",
        email_company: "Email ng kompanya",
        Password: "Password",
        min_password_length8: "Ang minimum na haba ng password ay 8 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        spcl_characters: "# ng mga karakter",
        lowercase_letter: "Maliit na letra",
        capital_letter: "Malaking letra",
        number: "Numero",
        special_character: "Espesyal na karakter",
        confirm_password: "Kumpirmahin ang Password",
        Phone_Number: "Numero ng telepono",
        have_read: "Aking nabasa, naunawaan at tinanggap ang",
        terms_conditions: "Mga Tuntunin at mga Kondisyon",
        accept_terms_conditions: "Mangyaring tanggapin ang mga tuntunin at mga kondisyon",
        given_your_residency: "Dahil sa iyong paninirahan, makakasama ka sa Triple A Experts Investment Services (GR) na kinokontrol ng HCMC. Maaari mong tingnan ang mga magagamit na mga proteksyon at mga tuntunin at mga kondisyon sa aming website. Sa pamamagitan ng pag-click na ",
        continue: "magpatuloy",
        triple_investment_services: "sumasang-ayon ka sa pagbubukas ng iyong account sa Triple A Experts Investment Services (GR).",
        register: "MAGPAREHISTRO",
        already_have_account: "May account ka na ba?",
        login: "Mag log-in",
        /*=== forgot-password.vue ====*/
        confirmation_link: "Isang link para sa kumpirmasyon ang naipadala sa iyong nakarehistrong email ID. Mangyaring i-click ang link para i-reset ang iyong login password.",
        ok: "OK",
        this_email_address: "Hindi nakarehistro sa amin ang email address na ito.",
        click_here: "I-click dito",
        create_account_now: "para gumawa ng account ngayon",
        forgot_password: "Nakalimutan ang password",
        email_address: "Email Address",
        submit: "Isumite",
        dont_have_account: "Wala ka bang account?",
        create_account_now_CAP: "LUMIKHA NG ACCOUNT NGAYON!",
        /*=== login.vue ====*/
        client_login: "Login para sa Kliyente",
        remember_me: "Tandaan mo ako",
        two_step_verification: "Dalawang hakbang na beripikasyon",
        google_authenticator: "Mangyaring ipasok ang one time passcode na ipinakita sa Google Authenticator app.",
        google_auth_code: "Google Auth Code",
        /*=== register.vue ====*/
        sent_an_OTP: "Nagpadala kami ng OTP sa",
        complete_your_registration: "Mangyaring ipasok ito upang matiyak at makumpleto ang iyong pagpaparehistro.",
        otp: "OTP",
        Register_heading: "Magparehistro",
        first_name: "Pangalan",
        last_name: "Apelyido",
        email: "Email",
        country: "Bansa",
        select_residence_country: "Pumili ng bansang tinitirahan",
        privacy_policy: "Patakaran sa Pagkapribado",
        accept_privacy_policy: "Mangyaring tanggapin ang patakaran sa pagkapribado",
        experts_investment_services: "Dahil sa iyong paninirahan, makakasama ka sa Triple A Experts Investment Services (GR) na kinokontrol ng HCMC. Maaari mong tingnan ang mga magagamit na mga proteksyon at mga tuntunin at mga kondisyon sa aming website. Sa pamamagitan ng pag-click na ",
        opening_your_account: "sumasang-ayon ka sa pagbubukas ng iyong account sa Triple A Experts Investment Services (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "Ang iyong password sa pag-log in ay matagumpay na nabago.",
        reset_password: "I-reset ang Password",
        reset: "I-reset",
    },
    //H
    copy_trading: {
        copy_trading: "Pagkopya sa Pangangalakal",
        copy_trading_header: "Kumita sa pamamagitan ng awtomatikong pangongopya sa mga kalakalan ng strategy manager",
        leading_traders: "AWTOMATIKONG KOPYAHIN ANG MGA NANGUNGUNANG MANGANGALAKAL",
        diversified_trading: "IBA’T IBANG URI NG PORTFOLIO SA PANGANGALAKAL",
        monitor_profit: "SUNDAN AT KUMITA",
        copy_traders: "PAANO KUMOPYA NG MGA KALAKALAN?",
        one: "1.",
        one_header: "Magbukas ng Live Account at magdeposito.",
        two: "2.",
        two_header: "Pumili ng Strategy Manager.",
        three: "3.",
        three_header: "Sumang-ayon sa mga tuntunin at mga kondisyon.",
        four: "4.",
        four_header: "Ibahagi sa amin ang iyong kasunduan.",
        five: "5.",
        five_header: "Kumita sa pamamagitan ng pangongopya ng mga kalakalan.",
        order_processing: "MABILIS NA PAGPROSESO NG ORDER",
        end_result: "KONTROL SA PANGWAKAS NA RESULTA",
        trading_skills: "PAHUSAYIN ANG IYONG KASANAYAN SA PANGANGALAKAL",
        start: "Start"
    },
    downloads: {
        mt_four_desktop: "MT4 para sa Desktop",
        mt_four_android: "MT4 para sa Android",
        mt_four_ios: "MT4 para sa iOS",
        mt_four_web_trader: "MT4 para sa Web Trader",
        mt_five_desktop: "MT5 para sa Desktop",
        mt_five_android: "MT5 para sa Android",
        mt_five_ios: "MT5 para sa iOS",
        mt_five_web_trader: "MT5 para sa Web Trader",
        act_trader_desktop: "Act Trader para sa Desktop",
        act_trader_android: "Act Trader para sa Android",
        act_trader_ios: "Act Trader para sa iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "Sigurado ka bang gusto mong kumuha ng VPS",
        package: "Package ?",
        yes: "Oo",
        no: "HINDI",
        downloads: "Mga Download",
        copy_trading: "Pagkopya sa Pangangalakal",
        vps: "VPS"
    },
    vps: {
        vps_plans: "Mga Plano ng VPS",
        bronze: "BRONZE",
        monthly_subscription_twenty_five: "Buwanang Bayarin $25",
        free_deposit_five_thousand: "Kunin ito nang libre kapag nagdeposito ng $5,000 o mas mahigit",
        compatible_mt_four_five_act: "Tugma para sa sa MT4, MT5 at Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "May libreng 25 GB na Disk Space | 1300 MB RAM | 1 VCPU",
        windows_linux_support: "Windows 8/10/12, Sinusuportahan ng Linux",
        avail_now: "Mag-avail na",
        silver: "SILVER",
        monthly_subscription_fourty_five: "Buwanang Bayarin $45",
        free_on_deposit_ten_thousand: "Kunin ito nang libre kapag nagdeposito na $10,000 o mas mahigit",
        free_fifty_gb_disk_space_ram_vcpu: "May libreng 50 GB na Disk Space | 2700 MB RAM | 2 VCPU",
        gold: "GOLD",
        monthly_subscription_eighty: "Buwanang Bayarin $80",
        free_on_deposit_fifteen_thousand: "Kunin ito nang libre kapag nagdeposito na $15,000 o mas mahigit",
        free_seventy_five_gb_disk_space_ram_vcpu: "Free 75 GB Disk Space | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Kanselahin ang Kahilingan na Mag-withdraw",
        cancel_your_withdrawal_request: "Sigurado ka bang gusto mong kanselahin ang iyong Kahilingan na Mag-withdraw",
        process_request: "Iproseso ang Kahilingan",
        open_tickets: "Buksan ang mga Ticket",
        back: "Bumalik",
        ticket_number: "Numero ng Ticket:",
        created: "Nilikha:",
        reason: "Dahilan:",
    },
    bonus: {
        request_to_avail_bonus: "Ang iyong kahilingan na mag-avail ng bonus ng",
        trading_id: "para sa trading ID",
        click_confirmation_link: "ay natanggap. Upang kumpirmahin, mangyaring i-click ang link para sa kumpirmasyon na ipinadala sa iyong nakarehistrong e-mail ID.",
        request_to_remove_bonus: "Ang iyong kahilingang alisin ang bonus ng",
        bonus_amount: "Ang halaga ng iyong bonus na",
        successfully_removed_account: "ay matagumpay na naalis mula sa account id",
        ok: "OK",
        request_to_add_bonus: "Ang iyong kahilingang magdagdag ng bonus ng",
        successfully: "ay matagumpay.",
        bonus: "BONUS",
        select_trading_id: "Piliin ang Trading ID",
        use_max: "Gamitin ang Pinakamataas",
        account_type: "Uri ng Account",
        equity: "Equity",
        leverage: "Leverage",
        currency: "Pera",
        current_bonus: "Kasalukuyang Bonus",
        allowed_bonus: "Pinahihintulutang Bonus",
        remove: "Tanggalin",
        account_first: "Mangyaring pumili muna ng account",
        bonus_amount_base_currency: "Paalala: Ipasok ang Halaga ng Bonus sa Baseng Pananalapi.",
        point_one: "1. Ang aming 100% Bonus Offer ay bukas sa lahat ng kliyente na may pinakamababang deposito na USD 100 at may account leverage na hanggang 1:200. Ang pinakamataas na bonus na pinahihintulutan ay USD 40,000 bawat kliyente.",
        point_two: "2. Ang kita mula sa mga kalakalan sa pamamagitan ng ating bonus ay mapapasaiyo lahat. Ang bonus ay hindi ibibigay kung kukunin mo ang iyong mga kinita.",
        point_three: "3. Pinapalaki ng bonus ang iyong magagamit na margin sa account. Gayunpaman, ang iyong mga pagkalugi ay hindi maaaring isama sa bonus. Kung ang kabuuang pagkalugi sa iyong mga kalakalan ay lumampas sa sarili mong pondo, awtomatikong ihihinto ng system ang mga posisyon sa iyong trading account nang walang anumang paunang abiso.",
        point_four: "4. Ang proporsyonal na halaga ng bonus ay kukunin mula sa iyong account kung magwi-withdraw ka ng sarili mong mga pondo.",
        read_understood_accepted: "Aking nabasa, naunawaan at tinanggap ang",
        aaafx_bonus_policy: "Patakaran sa Bonus ng AAAFx.",
        accept_aaafx_bonus_policy: "Mangyaring tanggapin ang patakaran sa bonus ng AAAFx",
        proceed: "Magpatuloy",
        no_bonus_available_account: "Walanag bonus ang magagamit para sa account na ito"
    },
    refer_earn: {
        bonus: "BONUS",
        refer_earn: "MAG-REFER AT KUMITA",
        refer_friend: "Mag-refer ng kaibigan",
        earn_dollar_twenty_five: "Kumita ng $25",
        per_friend: "bawat kaibigan",
        why_refer_someone_to_us: "Bakit dapat kang mag-refer sa amin?",
        refer_someone_point_one: "1. Makakatanggap ka at ang iyong kaibigan ng benepisyo ng referral bonus.",
        refer_someone_point_two: "2. Isang tuwiran at mabilis na pamamaraan",
        refer_someone_point_three: "3. Pareho kayong makikinabang mula sa aming kanais-nais na mga kondisyon ng pangangalakal.",
        refer_someone_point_four: "4. Ang mga kita mula sa mga referral ay walang hangganan.",
        what_need_to_do: "Ito ang kailangan mong gawin:",
        what_need_to_do_point_one: "1. Ipamahagi ang iyong referral link sa iyong mga kasama.",
        what_need_to_do_point_two: "2. Ang iyong mga referral ay magpaparehistro gamit ang iyong link at magsisimula sa trading.",
        what_need_to_do_point_three: "3. Sa sandaling maging kwalipikado ang iyong referral, pareho kayong makakakuha ng $25 bawat isa.",
        referral_list: "Ang Iyong Listahan ng mga referral"
    },
    referral_list: {
        referrals_list: "Listahan ng mga referral",
        list_of_referrals: "Listahan ng mga referral upang masubaybayan ang iyong mga kita.",
        s_no: "S.No.",
        name: "Pangalan",
        email_id: "Email ID",
        account_stage: "Account Stage",
        deposits: "Mga deposito",
        volume_required: "Kinakailangang Volume",
        traded_volume: "Volume na nai-trade",
        qualified: "Kwalipikado",
        no_data: "Walang data",
        payment_of_referral_bonus: "Ang pagbabayad ng Referral Bonus ay isasagawa sa linggong kasunod ng linggo kung saan ang Referral ay naging kwalipikado.",
        referral_bonus_paid_in_aaafx_wallet: "Ang Referral bonus ay babayaran sa AAAFx USD wallet na maaaring gamitin ng tagapag-refer at ang ini-refer na maaaring i-withdraw o ilipat sa kanilang trading account.",
        read_all_terms_conditions: "Basahin ang Lahat ng mga Tuntunin at mga Kondisyon",
        here: "dito",
        contact_us: "Mga anong? Makipag-ugnay sa amin sa Live Chat 24/5 o sumulat sa amin sa",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Mga Kahulugan",
        meaning_of_all_above_columns: "Ito ang mga kahulugan ng lahat ng mga talahanayan sa itaas para sa iyong reperensya:",
        name_of_your_referral: "- Pangalan ng iyong referral.",
        meaning_of_various_stages: "- Mangyaring tingnan ang sumusunod na kahulugan ng bawat yugto.",
        registered: "1. Nakarehistro:",
        registered_link: "Ang iyong referral ay nakapagrehistro gamit ang iyong link.",
        funded: "2. Pinondohan:",
        referral_deposited: "Nagdeposito ang iyong referral.",
        third_point_qualified: "3. Kwalipikado:",
        referral_has_deposited: "Ang iyong referral ay nagdeposito at umabot sa kinakailangang volume ng trade. Pareho na kayong kwalipikado para sa gantimpala.",
        deposits_made_by_referral: "- Mga deposito na isinagawa ng iyong referral.",
        volume_requirement: "Kinakailangang volume",
        volume_required_for_reward: "- Ang volume na kinakailangan para maging kwalipikado ang iyong referral para sa gantimpala.",
        volume_your_referral_traded: "- Ang aktwal na volume na naikalakal ng iyong referral.",
        referral_qualified_for_reward: "- Kung ang iyong referral ay naging kwalipikado na para sa gantimpala o hindi pa.",
        referral_ib_programs: "Matapos makakuha ng gantimpala sa 10 na mga referral, maaari kang maging isang IB o hindi kaya ay magpatuloy sa ilalim ng Mag-refer at Kumita na programa na may gantimpalang $20 bawat isa sa inyo ng iyong ini-refer. Maaari mong pagkumparahin ang mga benepisyo at mga nilalaman ng aming Referral at mga programa ng IB"
    },
    calculators_common: {
        asset_class: "Klase ng Asset",
        forex: "Forex",
        commodities: "Mga Commodity",
        indices: "Mga Index",
        account_base_currency: "Baseng Pananalapi ng Account",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Simbolo",
        select_symbol: "Piliin ang Simbolo",
        trade_size_in_lots: "Laki ng Trade(sa mga lote)",
        calculate: "Kalkulahin"
    },
    margin: {
        margin_required: "Kinakailangang Margin:",
        maximum_leverage: "Maximum na Leverage:"
    },
    pip: {
        pip_value: "Pip Value:"
    },
    swap: {
        server: "Server",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Bilang ng mga araw",
        long_swap: "Mahabang Pakikipagpalitan:",
        short_swap: "Maikling Pakikipagpalitan:"
    },
    //S
    dashboard:{
        select_trading_id: "Piliin ang Trading ID",
        leverage: "Leverage",
        balance: "Balanse",
        equity: "Equity",
        free_margin: "Libreng Margin",
        pnl: "PNL",
        web_trader : "Web Trader",
        fund: "Pondo",
        promotions: "Mga promosyon",
        hundred: "100",
        bonus: "Bonus",
        avail: "Mag-avail",
        deposit_bonus: "Bonus ng deposito",
        loading_initial_data: "Nilo-load ang paunang data",
    },
    enable_2fa:{
        title: "Google Authentication (2FA)",
        description: "Upang paganahin ang Google Two-factor (2FA) Authentication, i-scan ang QR code at ipasok ang one-time passcode sa ibaba.",
        google_authenticator_code: "Google Authenticator Code",
        how_to_enable: "Para Paganahin ang 2 Factor Authentication:",
        download: "I-download",
        google_authenticator_app: "Ang Google Authenticator App",
        on_mobile_tablet: "sa iyong mobile/tablet.",
        scan_the : "I-scan ang",
        qr_code: "QR code",
        appearing_above: "na lumalabas sa itaas",
        enter_the: "Ipasok ang",
        passcode: "Passcode",
        appers_in_google_auth_app: "na lumalabas sa iyong Google Authenticator App",
        click_on_the_button: "I-click ang button",
        click_to_enable: "I-click upang Paganahin",
    },
    account_security:{
        title: "Google Authentication (2FA)",
        description: "Upang paganahin ang Google Two-factor (2FA) Authentication, i-scan ang QR code at ipasok ang one-time passcode sa ibaba.",
        google_authenticator_code: "Google Authenticator Code",
        how_to_enable: "Para Paganahin ang 2 Factor Authentication:",
        download: "I-download",
        google_authenticator_app: "Ang Google Authenticator App",
        on_mobile_tablet: "sa iyong mobile/tablet.",
        scan_the : "I-scan ang",
        qr_code: "QR code",
        appearing_above: "na lumalabas sa itaas",
        enter_the: "Ipasok ang",
        passcode: "Passcode",
        appers_in_google_auth_app: "na lumalabas sa iyong Google Authenticator App",
        click_on_the_button: "I-click ang button",
        click_to_enable: "I-click upang Paganahin",
    },
    change_pass:{
        success_message:"Ang iyong password ay matagumpay na nabago.",
        ok:"OK",
        change_password: "Palitan ang password",
        existing_password: "Kasalukuyang Password",
        new_password: "Bagong Password",
        confirm_new_password: "Kumpirmahin ang Bagong Password",
        note_one: "Ang password ay dapat maglaman ng hindi bababa sa 7 at hindi lalagpas sa 10 na karakter, at dapat magtaglay ng di bababa sa 1 numero, 1 malaking letra, at 1 espesyal na karakter {'(!@#$%^)'}.",
        note_two: "Mangyaring tandaan na ang password ng Profile ay magkaiba sa password ng iyong trading account",
        cancel: "Kanselahin",
    },
    corporate_varify_step_three:{
        please_upload_file: "Mangyaring i-upload ang file",
        out_of_documents: "mula sa 8 na mga Dokumento",
        add_file: "Magdagdag ng file",
        max_file_size: "Maximum files size of can be uploaded up to"
    },
    corporate_varify:{
        corporation_info: 'Impormasyon ng Korporasyon',
        account_creation: "Paglikha ng Account",
        verification: "Beripikasyon",
        deposit: "Deposito",
        select_platform: "Piliin ang Plataporma",
        select_account_type: "Piliin ang Uri ng Account",
        select_leverage: "Piliin ang Leverage",
        select_base_currency: "Piliin ang Baseng Pananalapi ng Account",
        select_currency: "Piliin ang Pananalapi",
        password: "Password",
        pass_length_alert: "Ang minimum na haba ng password ay 5 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        of_characters: "ng mga karakter",
        lowercase_letter: 'Lowercase letter',
        capital_letter : "Malaking letra",
        number: "Numero",
        special_character : "Espesyal na karakter",
        confirm_password: "Kumpirmahin ang Password",
        create_account : "Lumikha ng Account",
    },
    corporation_info:{
        name_of_company: "Pangalan ng kompanya",
        country_of_company: "Bansa ng kompanya",
        select_company_country: "Piliin ang bansa ng kompanya",
        registration: "Pagpaparehistro",
        submit: "ISUMITE",
    },
    profile:{
        personal_details: "Personal na mga detalye",
        uploaded_documents: "Mga dokumentong in-upload",
        no_documents_yet: "Wala pang mga Dokumento",
    },
    questions:{
        financial_details: "Mga Detalyeng Pinansyal",
        sub_heading_one: "Tinatayang Pangkabuuang Taunang Kita",
        select_annual_income: "Piliin ang Taunang Kita",
        sub_heading_two: "Tinatayang Pangkabuuang Net Worth",
        sub_heading_two_desc: "Kabuuang mga asset matapos ibawas ang kabuuang mga pananagutan ng isang indibidwal o isang kumpanya.",
        select_net_worth:"Select Net Worth",
        sub_heading_three: "Industriya ng Trabaho",
        select_occupation: "Piliin ang Trabaho",
        sub_heading_four: "Ipasok ang Iba Pang Trabaho",
        sub_heading_five: "Pinagmulan ng Pondo",
        sub_heading_six: "Ipasok ang Iba Pang Mga Pinagmulan ng Pondo",
        sub_heading_seven: "US FATCA Reportable Person",
        sub_heading_eight: "Bansa/Hurisdiksyon ng buwis ng paninirahan",
        select_residence_country: "Pumili ng bansang tinitirahan",
        sub_heading_nine: "Ikaw ba ay may TIN Number?",
        sub_heading_ten: "Ipasok ang TIN Number",
        sub_heading_eleven: "Kung walang TIN na maaring gamitin ay ipasok ang Dahilan",
        select_reasons: "Piliin ang Mga Dahilan",
        enter_reason: "Ipasok ang Dahilan",
        submit: "Isumite",
        dear: "Minamahal na",
        message_one: "Batay sa impormasyong ibinigay mo, lumilitaw na ikaw ay isang residente ng Estados Unidos para sa mga layuning pambuwis.",
        message_two: "Mangyaring tandaan na dahil sa aming Pang-regulasyon na Pagsunod, hindi maaaring tanggapin ng AAAFx ang kliyente na residente ng Estados Unidos para sa mga layuning pambuwis.",
        message_three: "Pauna kaming nagpapasalamat sa iyo para sa iyong pag-unawa.",
        message_four: "Taos-pusong sumasaiyo,",
        message_five: "AAAFx",
        close: "Isara",
    },
    verify:{
        account_creation: "Paglikha ng Account",
        financial_details: "Mga Detalyeng Pinansyal",
        verification: "Beripikasyon",
        deposit: "Deposito",
        select_platform: "Piliin ang Plataporma",
        select_account_type: "Piliin ang Uri ng Account",
        select_leverage: "Piliin ang Leverage",
        select_base_currency: "Piliin ang Baseng Pananalapi ng Account",
        select_currency: "Piliin ang Pananalapi",
        password: "Password",
        pass_message_one: "Ang minimum na haba ng password ay 5 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        pass_message_two: "Ang minimum na haba ng password ay 8 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        of_characters: "ng mga karakter",
        lowercase_letter: "Maliit na letra",
        capital_letter: "Malaking letra",
        number: "Numero",
        special_character: "Espesyal na karakter",
        confirm_password: "Kumpirmahin ang Password",
        create_account: "Lumikha ng Account",
        doc_message_one: "Ang mga dokumentong iyong isinumite ay di tinanggap ng awtomatikong proseso ng beripikasyon. Nailikha ang isang ticket patungkol dito kung saan maaari mong i-upload muli ang iyong mga dokumento para sa aming manwal na pagtitiyak ng mga dokumento kung iyong nanaisin.",
        view_ticket: "Tingnan ang Ticket",
    },
    verify_quest_bkp:{
        account_creation: "Paglikha ng Account",
        questionnaire: "Palatanungan",
        verification: "Beripikasyon",
        deposit:"Deposit",
        select_platform: "Piliin ang Plataporma",
        select_account_type: "Piliin ang Uri ng Account",
        select_leverage: "Piliin ang Leverage",
        select_base_currency: "Piliin ang Baseng Pananalapi ng Account",
        select_currency: "Piliin ang Pananalapi",
        password: "Password",
        pass_length_alert: "Ang minimum na haba ng password ay 5 karakter at dapat maglaman ng hindi bababa sa 1 maliit na letra, 1 malaking letra 1 numero at 1 espesyal na karakter.",
        of_characters: "ng mga karakter",
        lowercase_letter: "Maliit na letra",
        capital_letter: "Malaking letra",
        number: "Numero",
        special_character: "Espesyal na karakter",
        confirm_password: "Kumpirmahin ang Password",
        create_account: "Lumikha ng Account",
        doc_message_one: "Ang mga dokumentong iyong isinumite ay di tinanggap ng awtomatikong proseso ng beripikasyon. Nailikha ang isang ticket patungkol dito kung saan maaari mong i-upload muli ang iyong mga dokumento para sa aming manwal na pagtitiyak ng mga dokumento kung iyong nanaisin.",
        view_ticket: "Tingnan ang Ticket",
    },
    close_ticket:{
        heading: "Mga Saradong Ticket",
        create_request: "GUMAWA NG KAHILINGAN",
        open_tickets: "BUKAS NA MGA TICKET",
        ticket_number: "Numero ng Ticket",
        trading_id: "Trading ID",
        status: "Estado",
        subject: "Paksa",
        created: "Nilikha",
        closed: "Isinara",
        action: "Aksyon",
        view_ticket: "Tingnan ang Ticket",
        no_tickets_found: "Walang natagpuang anumang ticket",
    },
    open_ticket:{
        heading: "Buksan ang mga Ticket",
        create_request: "GUMAWA NG KAHILINGAN",
        open_tickets: "BUKAS NA MGA TICKET",
        closed_ticket: "Mga Saradong Ticket",
        ticket_number: "Numero ng Ticket",
        trading_id: "Trading ID",
        status: "Estado",
        subject: "Paksa",
        created: "Nilikha",
        action: "Aksyon",
        view_ticket: "Tingnan ang Ticket",
        no_tickets_found: "Walang natagpuang anumang ticket",
    },
    request_call:{
        success_message:"Ang iyong hiling para sa ikaw aay matawagan ay natanggap. Ang aming grupo ay makikipag-ugnayan sa iyo maya-may.",
        ok: "OK",
        request_call_back:"Humiling ng Pagtawag",
        first_name: "Pangalan",
        last_name: "Apelyido ",
        email_id: "Email ID",
        phone_number: "Numero ng telepono",
        timezone: "Timezone",
        date: "Petsa",
        preferred_time: "Nais na Oras",
        department: "Kagawaran",
        select_department: "Pumili ng kagawaran",
        new_accounts: "Mga Bagong Account",
        deposits: "Mga deposito",
        withdrawals: "Mga withdrawal",
        partnership: "Pakikipagtulungan",
        technical_support: "Suportang Teknikal",
        message: "Mensahe",
        send_request: "Magpadala ng Kahilingan",
    },
    support_page:{
        success_message:"Matagumpay na nalikha ang isang Ticket ng Suporta para sa iyo. Maaaro mo itong subaybayan sa bahing Open Tickets.",
        ok:"OK",
        support: "Suporta",
        create_req:"LUMIKHA NG KAHILINGAN",
        open_tickets:"BUKAS NA MGA TICKET",
        closed_tickets: "MGA ISINARANG TICKET",
        otp_msg:"Nagpadala kami ng OTP sa nairehistrong email. Mangyaring ipasok ito upang maberipika ang hiling sa ticket ng suporta.",
        otp: "OTP",
        submit: "Isumite",
        reason: "Dahilan",
        select_a_reason: "Pumili ng dahilan",
        trading_id: "Trading ID",
        select_trading_account: "Piliin ang Trading Account",
        subject: "Paksa",
        trade_order_id: "Trade Order ID",
        time_of_trade_opening: "Oras ng Pagbukas ng Trade",
        time_of_trade_closing: "Oras ng Pagsara ng Trade",
        instrument_traded: "Nai-trade na Instrumento",
        type_of_trade: "Uri ng Trade",
        select_trade_type: "Piliin ang uri ng Trade",
        details_of_the_issue: "Mga detalye ng isyu",
        refund_claim_amount: "Halaga ng Refund Claim",
        message: "Mensahe",
        note: "PAALALA",
        file_attachments: "Mga Attachment ng File",
        file_size_msg: "Ang laki ng dokumento ay hindi dapat hihigit sa 1MB",
        file_format_msg: "Format ng file (jpeg o pdf) lamang",
        lowercase_note: "Paalala",
        note_desc: "Sa kaso ng anumang mali habang gumagawa ng anumang operasyon sa account, mangyaring ilagay din ang screenshot habang gumagawa ng ticket",
        create_support_request: "Lumikha ng Kahilingang Pangsuporta",
    },
    become_ib:{
        heading: "Pagpapakilala ng Broker",
        description: "Palakasin ang Iyong mga kita sa pamamagitan ng aming IB Program. <br /> Kunin ang iyong nakalaang link, ipamahagi ito sa iyong mga kaibigan at kumita mula sa komisyon sa tuwing sila ay nagti-trade.",
        sub_heading: "Nag-aalok kami dalawang kategorya ng mga programang pang-IB:",
        point_one: "Karaniwang IB Program- Direktang tumanggap ng 20% sa aming kita mula sa komisyon mula sa iyong mga kliyente. Ito ay kapaki-pakinabang para sa isang baguhang IB na nais magsimulang muli o maaaring magsimulang magdala ng limitadong dami ng mga kliyente sa amin.",
        point_two: "Advanced na IB Program- Ito ay lubos na kapaki-pakinabang at inangkop na IB program para sa ating mas malalaking IB. Kapaki-pakinabang ito para sa sinuman na may malawak na base ng mga kliyente na kayang magdala ng mas mataas na volume.",
        note_one: "Maaari kang lumipat mula sa Pangkaraniwang IB Program patungo sa Abansadong IB Program, kapag napalaki mo na ng husto ang iyong network.",
        earn_with: "Kumita ng",
        zero_investment_or: "walang anumang pamumuhunan o",
        experience: "karanasan",
        weekly_ib: "Lingguhang IB",
        commissions: "na mga Komisyon",
        payouts: "mg pagbabayad",
        unlimited: "Walang hangganan",
        earnings: "mga kita",
        potential: "potensyal",
        sub_cont_point_four: "Lubos na nakaangkop at kapaki-pakinabang na advanced na IB Program",
        ultra_fast: "Napakabilis",
        withdrawals_of_ib: "na mga withdrawal ng IB",
        commission: "komisyon",
        easy_user: "Madaling user",
        interface_of: "interface ng",
        ib_portal: "IB Portal",
        dedicated: "Dedikadong",
        account: "Account",
        manager: "Manager",
        helpful_and: "Matulungin at",
        free_marketing: "Libreng Marketing",
        material: "na Materyales",
        become_an_ib: "Maging isang IB",
    },
    pamm_acct:{
        title:"PAMM ACCOUNT",
        description_one: "Ang PAMM (Percentage Allocation Management Module) ay isang managerial account kung saan ang tagapamahala ay nagsasagawa ng mga trade para sa lahat ng mga sub-account nito. Ang tagapamahala at ang mga Namumuhunan ay malayang pumili ng istraktura ng bayad sa pagganap, at kami na ang bahala sa pagsasaayos nito.",
        description_two: "Nagbibigay ang AAAFx ng lubos na flexible at nakaangkop na mga solusyon sa pagti-trade ng PAMM.",
        sub_title: "Paano magpalista bilang PAMM Manager",
        sub_Point_one: "Maaaring mabuksan ang iyong PAMM Manager account kapag mayroon kang hindi bababa sa apat na mamumuhunan na may kabuuang deposito na $5,000 o mahigit.",
        sub_Point_two: "Magparehistro lamang bilang IB para maging isang PAMM Manager sa amin. Iparehistro ang iyong mga kliyente gamit ang iyong link sa IB, at tuparin ang unang kundisyon sa itaas.",
        sub_Point_three: "Makipag-ugnay sa amin sa pamamagitan ng Live Chat o mag-email sa amin sa",
        sub_Point_four: "Magsimulang kumita ng komisyon sa IB bilang karagdagang Bayad sa Pagganap sa PAMM.",
        minimul_investment: "MABABANG PAMUMUHUNAN",
        ease_of_access: "DALI NG ACCESS",
        ultimate_trading_conditions: "PANGHULING MGA KONDISYON SA TRADING",
        trade_security: "SEGURIDAD NG KALAKALAN",
        request_pamm: "Humiling ng PAMM",
    },
    add_payment_methods:{
        success_message: "Ang iyong paraan ng pagbayad ay matagumpay na naidagdag. Maaari mo itong subaybayan sa Open Tickets.",
        ok: "OK",
        otp_message: "Nagpadala kami ng OTP sa iyong nakarehistrong email. Mangyaring ipasok ito upang maberipika ang kahilingan sa tiket ng suporta.",
        otp: "OTP",
        submit: "Isumite",
        page_heading: "Magdagdag ng Mga Paraan ng Pagbayad",
        select_payment_method: "Pumili ng Paraan ng Pagbayad",
        select_method: "Piliin ang Paraan",
        bank: "Bangko",
        credit_card: "Credit Card",
        crypto: "Crypto",
        select_crypto_currency: "Piliin ang Crypto Currency",
        select_crypto: "Piliin ang Crypto",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Idagdag ang Iyong Mga Detalyeng Pambangko",
        bank_name: "Pangalan ng Bangko",
        account_name: "Pangalan ng Account",
        account_number: "Numero ng Account",
        country: "Bansa",
        select_country: "Piliin ang bansa",
        iban: "IBAN",
        iban_note: "Hindi nagbibigay ng IBAN ang aking bangko",
        swift: "SWIFT",
        bic: "BIC",
        sort_code: "Sort Code",
        bank_address: "Address ng Bangko",
        upload_your_bank_statement: "I-upload ang Iyong Bank Statement",
        upload_doc_info_one: "Ang laki ng dokumento ay hindi dapat hihigit sa 1MB",
        upload_doc_info_two: "Format ng file (jpeg o pdf) lamang",
        note: "Paalala",
        note_msg: "Sa kaso ng anumang mali habang gumagawa ng anumang operasyon sa account, mangyaring ilagay din ang screenshot habang gumagawa ng ticket",
        create_support_request: 'Create Support Request',
        add_your_card_details: "Idagdag ang Mga Detalye ng Iyong Card",
        creadit_card_number: "Numero ng Credit Card",
        month: "Buwan",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Taon",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "Kinakailangan namin ang sumusunod para sa beripikasyon ng card",
        varification_msg_one: "May kulay na kopya ng harapang bahagi ng card na ipinapakita ang: buong pangalan, petsa ng pagkawalang-bisa, Pangalan/ng bangko/logo, unang 4 at huling 4 na numero ng credit card habang itinatago ang gitnang 8 numero.",
        upload_supporting_document: "Mag-upload ng Pansuportang Dokumento",
        varification_msg_two: "May kulay ng kopya ng panlikod na bahagi ng card na tinatago ang CVV security code. Ang kopyang panlikod ay dapat magtaglay ng lagda ng nagmamay-ari nito.",
        add_selected_crypto_address: "Magdagdag ng Napiling Crypto Address",
        address: "Address",
    },
    deposit:{
        account_type: "Uri ng Account",
        select_type: "Pumili ng uri",
        live: "Live",
        trading_account: "Trading Account",
        select_trading_account: "Piliin ang Trading Account",
        balance: "Balanse",
        fund: "PONDO",
        amount: "Halaga",
        region: "Lalawigan",
        currencies: "Mga Pananalapi",
        processing_time: "Oras ng Pagpoproseso",
        action: "Aksyon",
        view_more: "Tingnan ang Iba Pa",
        currency: "Pera",
        zar: "ZAR",
        swift_code: "Swift Code",
        beneficiarys_name: "Pangalan ng benepisyaryo",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Numero ng Account",
        user_account_number: "62928423269",
        bank_address: "Address ng Bangko",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Pangalan ng Bangko",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "Lungsod",
        city_info: "London",
        country: "Bansa",
        country_info: "United Kingdom",
        dixipay_note: "Tumatanggap ang Dixipay ng mga deposito sa EURO lamang",
        you_can_deposit: "Maaari kang magdeposito",
        you_can_deposit_msg: "sa sumusunod na address at ang katumbas na halaga sa napiling pananalapi ng account ay idadagdag matapos ang pagpalit nito",
        copy: "Kopya",
        done: "Tapos na",
        network_msg: "Ang ERC-20 network (USDT, USDC, ETH) ay suportado, ang paggamit ng anumang iba pang network ay hindi makakarating sa amin.",
    },
    fund_index: {
        add_funds: "Magdagdag ng mga Pondo",
        cancel: "Kanselahin",
        ok: "OK",
        your_request_to_add: "Ang iyong kahilingan na magdagdag",
        to_your_demo_account_number: "sa iyong Demo Account Number",
        has_been_successfully_completed: "ay matagumpay na nakumpleto",
        your_request_to_withdraw: "Ang iyong kahilingang mag-withdraw",
        from_the_trading_id: "mula sa trading ID",
        has_been_received: "ay natanggap",
        click_to_proceed_withdrawal: "Mangyaring i-click ang link ng kumpirmasyon na ipinadala sa iyong nakarehistrong email ID upang maproseso ang pag-withdraw",
        has_been_successfully: "ay matagumpay na",
        your_request_to_add_usd: "Ang iyong kahilingang magdagdag ng USD",
    },
    request_verify: {
        verifying_your_request: "Tinitiyak ang iyong kahilingan",
        success: "TAGUMPAY",
        go_to_transactions: "Magtungo sa Mga Transaksyon",
        error: "MALI",
    },
    transactions: {
        list_of_transactions: "Listahan ng mga Transaksyon",
        deposits: "Mga deposito",
        withdrawals: "Mga withdrawal",
        bonus: "Bonus",
        deposit_transactions: "Mga Transaksyon ng Deposito",
        filter_by: "I-filter ayon sa",
        select_trading_id: "Piliin ang Trading ID",
        all: "LAHAT",
        date: "Petsa",
        account_id: 'Account ID',
        currency: "Pera",
        payment_mode: "Paraan ng pagbabayad",
        deposit_amount: "Halaga ng Deposito",
        status: 'Status',
        no_deposits_yet: "Wala pang deposito",
        withdrawal_mode: "Paraan ng Pag-withdraw",
        withdrawal_amount: "Halaga ng Iwi-withdraw ",
        action: "Aksyon",
        view_more : "Tingnan ang Iba Pa",
        no_withdrawals_yet: "Wala pang nai-withdraw",
        bonus_amount: "Halaga ng Bonus",
        pending : "Nakabinbin",
        no_bonus_transactions_yet: "Wala pang bonus na transaksyon",
        deposit_currency: "Pananalapi ng Deposito",
        account_currency: 'Pananalapi ng Account',
        address: 'Address',
    },
    withdrawal: {
        kyc_req_msg: "Kinakailangang kumpletuhin ang KYC bago humiling ng pag-withdraw. Mangyaring magsumite ng patunay ng tirahan gamit ang isang support ticket",
        Click_here: "I-click dito",
        or_email_to: 'or email to',
        with_step_heading: "Ang mga sumusunod na Patunay ng Tirahan ay tinatanggap",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Bill ng Utility",
        with_step_two: "Statement ng Bangko",
        with_step_three: "Dokumentong Pambuwis na Inisyu ng Pamahalaan",
        note: "Paalala",
        note_info: "Ang patunay ng tirahan ay kailangang hindi lalampas sa 4 na buwan",
        ok: "OK",
        enable_2fa_msg: "Kinakailangang paganahin ang 2FA upang makahiling ng pag-withdraw. Mangyaring i-click ang sumusunod na button",
        click_to_enable: "I-click upang Paganahin",
        select_trading_id: "Piliin ang Trading ID",
        account_id: "Account ID",
        account_type: "Uri ng Account",
        platform: 'Plataporma',
        leverage: "Leverage",
        currency: "Pera",
        free_margin: "Libreng Margin",
        note_info_two: "Ipasok ang halaga ng Iwi-withdraw sa Baseng Pananalapi ng iyong TradingAccount.",
        amount: "Halaga",
        mode_of_payment: "Paraan ng Pagbayad",
        create_transaction: "Lumikha ng Transaksyon",
        cancel: "Kanselahin",
        add_payment_method: "Magdagdag ng Paraan ng Pagbayad",
        no_amount_available: "Walang Halaga ang makukuha sa account na ito",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Pumili ng account",
    },
    footer: {
        legal_information: "Legal na Impormasyon",
        legal_information_info: "Ang Sikhula Venture Capital (Pty) Ltd. ay pinahintulutan at pinamamahalaan ng South African Financial Sector Conduct Authority (FSCA No. 2017/315029/07).",
        risk_warning: "Babala sa Panganib",
        risk_warning_info: `Ang pangangalakal ng mga pananalaping spot ay may kalakip na malalaking panganib at laging merong potensyal sa pagkalugi. Maaaring mag-iba ang iyong mga resulta sa pangangalakal. Dahil mataas ang panganib sa pangangalakal ng pananalaping pandayuhan, dapat gamitin lamang ang tunay na pondong pwedeng “i-risk” sa naturang trading. Kung wala kang hawak na kapital na pwede mong ipangtalo, hindi ka dapat mangalakal sa forex market. Walang anumang "ligtas" na sistema ng pangangalakal ang nailikha, at walang sinuman ang makakagarantiya ng mga kita o lubos na kalayaan mula sa pagkalugi.`,
    },
    header: {
        welcome: "Maligayang pagdating", 
        profile: 'Profile',
        request_callback: "Humiling ng Callback",
        support_ticket: "Ticket ng Suporta",
        change_password: "Palitan ang password",
        logout: "Mag-logout",
    },
    pagination: {
        total_records: "Kabuuang Mga Tala", 
    },
    side_bar: {
        dashboard: "Dashboard",
        manage_accounts: "Pangasiwaan ang Mga Account",
        fund: "Pondo",
        bonus: "Bonus",
        become_a_partner: "Maging Katuwang",
        tools: "Mga Kasangkapan",
        bonus_and_promotions: 'Bonus at mga Promosyon',
    },
    success_box: {
        otp_varify: "Pakilagay ang 6 na digit na One-Time Pin na ipinapakita sa Google Authenticator app.",
        cancel: "Kanselahin",
        submit: 'Submit',
        trouble_with_2fa: "Nagkakaroon ka ba ng Problema sa iyong Two-Factor Authentication Code?",
        click_varify_with_email: "Mag-click Dito Upang Mag-verify Gamit ang Email",
        or: "O",
        click_here: "I-click dito",
        to_enable_2fa: "upang paganahin ang iyong 2FA at kumpletuhin ang iyong kahilingan",
        take_me_back: "Ibalik mo ako",
    },
    tost_message: {
        varify_acc: "Mangyaring i-verify ang iyong account upang lumikha ng live account",
        click_to_begin: "I-click upang simulan ang proseso ng beripikasyon",
    },
    proof_residence_alert: {
        you_have: "meron kang",
        days_left_for_proof: "araw na nalalabi upang isumite ang katibayan ng tirahan.",
        click_here: "I-click dito",
        to_upload: "para mag-upload",
    },
    closed_trades: {
        login: "Mag log-in",
        order: "Order",
        symbol: "Simbolo",
        volume: "Dami",
        open_price: "Presyo ng Pagbukas",
        open_time: "Oras ng Pagbukas",
        commission: "Komisyon",
        type: 'Uri',
        sl: "SL",
        tp: "TP",
        close_price: 'Isarado ang Presyo',
        close_time: 'Isarado ang Oras',
        swap: 'Ipagpalit',
        pnl: "PNL",
        comment: 'Komento',
        no_record_found: "Walang natagpuang record",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Simbolo',
        type: 'Uri',
        volume: "Dami",
        open_price: "Presyo ng Pagbukas",
        pnl: "PNL",
        no_record_found: "Walang natagpuang record",
    },
}